import get from 'lodash/get'
import { required, idCardNumber, validDateInFuture, birthNumber } from '../../utils/validations'

const validate = (values: any) => ({
  identityCardNumber: idCardNumber(get(values, 'identityCardNumber')),
  identityCardExpiration: validDateInFuture(get(values, 'identityCardExpiration')),
  personalIdentificationNumber:
    required(get(values, 'personalIdentificationNumber')) ||
    birthNumber(get(values, 'personalIdentificationNumber')),
  maritalStatus: required(get(values, 'maritalStatus')),
  citizenship: required(get(values, 'citizenship')),
  placeOfBirth: required(get(values, 'placeOfBirth')),
  countryOfBirth: required(get(values, 'countryOfBirth')),
})

export default validate
